/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-constructed-context-values */
/* eslint-disable import/extensions */
import { useRouter } from 'next/router';
import React, { useEffect, useState, } from 'react';
import { Button, Modal, Form, Row, Col, InputGroup, } from 'react-bootstrap';
import { FaEye, FaEyeSlash } from 'react-icons/fa6';
import { InputMask } from 'primereact/inputmask';
import { layout, messages, format, validate, http, extract, } from '@/helpers/index';
import { auth } from '@/services/auth';
import { constant } from '@/helpers/constant';
import Divider from '@/components/divider';

export default function SignModal({ path, setUser, setShow }) {
  const router = useRouter();
  const initial = { username: '', password: '', token: '', };
  const [currentUser, setCurrentUser] = useState(initial);
  const [body, setBody] = useState(initial);
  const [loginShow, setLoginShow] = useState(true);
  const [forgotPasswordShow, setForgotPasswordShow] = useState(false);
  const [registerShow, setRegisterShow] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const redirect = (logged) => {
    if (registerShow) {
      router.push(layout.back.get() || '/perfil/comprar-credito');
    }
    if (loginShow) {
      const crm = logged?.roles.filter((el) => !['USER', 'LEADS'].includes(el)).length > 0;
      let uri = layout.back.get() || (crm ? '/crm/mix' : '/perfil/minha-area');
      if (!crm && !layout.back.get() && logged.leads) {
        uri = '/perfil/leads';
      }
      router.push(path ?? uri);
    }
    layout.back.remove();
  };

  const handleInputChange = ({ target }) => {
    const { name, value } = target;
    if (name === 'token') {
      setBody({ ...body, [name]: extract.onlyNumbers(value) });
      return;
    }
    setBody({ ...body, [name]: value });
  };

  const handleCancel = () => {
    setUser();
    setShow(false);
    setLoginShow(false);
    setForgotPasswordShow(false);
    setRegisterShow(false);
  };

  const handleRegister = () => {
    if (window.location.pathname === '/cadastrar') { return; }
    if ((path && !window.location.pathname.includes(path)) || (!path && window.location.pathname !== '/')) {
      router.push('/cadastrar');
      return;
    }
    messages.clear();
    setLoginShow(false);
    setForgotPasswordShow(false);
    setRegisterShow(true);
    layout.focus('name');
  };

  const handleLogin = () => {
    if (window.location.pathname === constant.redirect.login) { return; }
    if ((path && !window.location.pathname.includes(path)) || (!path && window.location.pathname !== '/')) {
      router.push(constant.redirect.login);
      return;
    }
    messages.clear();
    setRegisterShow(false);
    setForgotPasswordShow(false);
    setLoginShow(true);
    layout.focus('username');
  };

  const handleForgotPassword = () => {
    messages.clear();
    setRegisterShow(false);
    setLoginShow(false);
    setForgotPasswordShow(true);
    layout.focus('email');
  };

  const onSubmitLogin = (e) => {
    e.preventDefault();
    messages.clear();
    layout.loading(true);
    http.post('/security/auth', body, (result, resultError, status) => {
      if (result) {
        setUser(result.user);
        setCurrentUser(result.user);
        if (result.user.otpActive && !result.token) {
          layout.focus('token');
          layout.loading(false);
          return;
        }
        auth.store.logged.set(result.user);
        auth.store.token.set(result.token);
        setLoginShow(false);
        redirect(result.user);
        return;
      }
      layout.loading(false);
      if (status === 401) {
        messages.error('Credenciais inválidas!', false, true);
        return;
      }
      if (status === 403) {
        messages.error('Acesso negado.', false, true);
        return;
      }
      if (resultError?.message) {
        messages.error(resultError.message, false, true);
        return;
      }
      messages.error('Ocorreu um erro ao realizar sua autenticação. Por favor, entre em contato com nosso suporte.', false, true);
    });
  };

  const onSubmitForgotPassword = (e) => {
    e.preventDefault(e);
    layout.loading(true);
    messages.clear();
    const body = {
      email: e.currentTarget.email.value,
    };

    http.post('/security/password/reset', body, (result, resultError) => {
      layout.loading(false);
      if (result) {
        e.target.reset();
        messages.success(result.message, false, true);
        return;
      }
      messages.error(resultError.message, false, true);
    });
  };

  const onSubmitRegister = (e) => {
    e.preventDefault();
    messages.clear();
    const passwordConfirm = e.currentTarget.passwordConfirm.value;
    const body = {
      email: e.currentTarget.email.value,
      name: format.capitalize(e.currentTarget.name.value),
      document: e.currentTarget.document.value,
      password: e.currentTarget.password.value,
      mobile: e.currentTarget.mobile.value,
      city: format.capitalize(e.currentTarget.city.value),
      state: e.currentTarget.state.value,
      termAgree: e.currentTarget.termAgree.checked,
    };
    if (!validate.cpf(body.document)) {
      messages.error('Por favor, informe um CPF válido.', false, true);
      e.currentTarget.document.focus();
      return;
    }
    if (!body.mobile || body.mobile.replaceAll(/[()-\s]/g, '').length < 11) {
      messages.error('Por favor, informe um Telefone Celular válido.', false, true);
      e.currentTarget.mobile.focus();
      return;
    }
    if (!body.email || !validate.email(body.email)) {
      messages.error('Por favor, informe um E-mail válido.', false, true);
      e.currentTarget.email.focus();
      return;
    }
    if (body.password !== passwordConfirm) {
      messages.error('Por favor, confirme sua senha no campo <strong>Confirmar Senha</strong>.', false, true);
      e.currentTarget.passwordConfirm.focus();
      return;
    }
    if (!body.termAgree) {
      messages.error('Por favor, aceite os termos de uso para continuar.', false, true);
      e.currentTarget.termAgree.focus();
      return;
    }
    layout.loading(true);
    http.post('/users', body, (result, resultError) => {
      layout.loading(false);
      if (result) {
        auth.store.logged.set(result.user);
        auth.store.token.set(result.token);
        setRegisterShow(false);
        redirect();
        return;
      }
      messages.error(resultError?.message ?? 'Ocorreu um erro ao realizar seu cadastro. Por favor, aguarde alguns instantes e tente novamente, ou entre em contato pelo e-mail: contato@aboutcar.com.br.', false, true);
    });
  };

  useEffect(() => {
    layout.focus('username');
  }, [])

  return (
    <>
      <Modal show={loginShow} onHide={handleCancel} backdrop="static" size="md" aria-labelledby="contained-modal-title-vcenter" centered>
        <Form onSubmit={onSubmitLogin}>
          <Modal.Header closeButton>
            <h2 className="text-center not-printable featurette-heading mt-1">Acesse sua Conta</h2>
          </Modal.Header>
          <Modal.Body>
            <Form.Group>
              <Form.Label htmlFor="username" className="oswald">E-mail</Form.Label>
              <Form.Control type="email" id="username" name="username" aria-describedby="emailHelp" placeholder="Digite seu e-mail" required value={body.username} onChange={handleInputChange} disabled={currentUser?.otpActive} />
            </Form.Group>
            <Form.Group>
              <Form.Label htmlFor="password" className="oswald">Senha</Form.Label>
              <InputGroup>
                <Form.Control type={showPassword ? 'text' : 'password'} id="password" name="password" placeholder="Digite sua senha" required autoComplete="current-password" value={body.password} onChange={handleInputChange} disabled={currentUser?.otpActive} />
                <Button onClick={() => { setShowPassword(!showPassword); }} title={showPassword ? 'Ocultar senha' : 'Mostrar senha'}>
                  {!showPassword && <FaEye />}
                  {showPassword && <FaEyeSlash />}
                </Button>
              </InputGroup>
            </Form.Group>
            {currentUser?.otpActive && (
              <Form.Group>
                <Form.Label htmlFor="token" className="oswald">Código de Autenticação</Form.Label>
                <Form.Control type="text" id="token" name="token" maxLength={6} aria-describedby="otpTokenHelp" placeholder="Digite o código de autenticação" required value={body.token} onChange={handleInputChange} />
              </Form.Group>
            )}
          </Modal.Body>
          <Divider color="gray" />
          <div className="d-grid gap-2 ps-3 pe-3 pb-3">
            <Button type="submit" className="shadow-sm">{currentUser?.otpActive ? 'Confirmar' : 'Entrar'}</Button>
            {!currentUser?.otpActive && (
              <>
                <Button variant="secondary" className="shadow-sm" onClick={handleRegister}>Não tenho cadastro</Button>
                <Button variant="light" className="shadow-sm" onClick={handleForgotPassword}>Esqueci minha senha</Button>
              </>
            )}
          </div>
        </Form>
      </Modal>
      <Modal show={forgotPasswordShow} onHide={() => setForgotPasswordShow(false)} backdrop="static" size="md" aria-labelledby="contained-modal-title-vcenter" centered>
        <Form onSubmit={onSubmitForgotPassword}>
          <Modal.Header closeButton>
            <h2 className="text-center not-printable featurette-heading mt-1">Esqueceu sua Senha?</h2>
          </Modal.Header>
          <Modal.Body>
            <div>Informe seu e-mail abaixo e lhe enviaremos um link para cadastrar sua nova senha.</div>
            <br />
            <Form.Group>
              <Form.Label htmlFor="email" className="oswald">E-mail</Form.Label>
              <Form.Control id="email" type="email" name="email" placeholder="Digite seu E-mail" required />
            </Form.Group>
          </Modal.Body>
          <Divider color="gray" />
          <div className="d-grid gap-2 ps-3 pe-3 pb-3">
            <Button type="submit" className="shadow-sm">Solicitar</Button>
            <Button variant="light" className="shadow-sm" onClick={handleLogin}>Cancelar</Button>
          </div>
        </Form>
      </Modal>
      <Modal show={registerShow} onHide={() => setRegisterShow(false)} backdrop="static" size="md" aria-labelledby="contained-modal-title-vcenter" centered>
        <Form onSubmit={onSubmitRegister}>
          <Modal.Header closeButton>
            <h2 className="text-center not-printable featurette-heading mt-1">Cadastre sua Conta</h2>
          </Modal.Header>
          <Modal.Body>
            <Form.Group>
              <Form.Label htmlFor="name" className="oswald">Nome Completo</Form.Label>
              <Form.Control type="text" name="name" id="name" placeholder="Digite seu Nome Completo" required />
            </Form.Group>
            <Row>
              <Col xs={12} sm={6}>
                <Form.Group>
                  <Form.Label htmlFor="document" className="oswald">CPF</Form.Label>
                  <InputMask name="document" id="document" className="form-control" mask="999.999.999-99" slotChar="" aria-describedby="documentHelp" placeholder="Digite seu CPF" required />
                </Form.Group>
              </Col>
              <Col xs={12} sm={6}>
                <Form.Group>
                  <Form.Label htmlFor="mobile" className="oswald">Telefone Celular</Form.Label>
                  <InputMask name="mobile" id="mobile" className="form-control" mask="(99) 99999-9999" slotChar="" placeholder="Digite seu Telefone Celular" required />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={6}>
                <Form.Group>
                  <Form.Label htmlFor="city" className="oswald">Cidade</Form.Label>
                  <Form.Control id="city" name="city" type="text" placeholder="Digite sua Cidade" required />
                </Form.Group>
              </Col>
              <Col xs={12} sm={6}>
                <Form.Group>
                  <Form.Label htmlFor="state" className="oswald">Estado</Form.Label>
                  <Form.Select name="state" id="state" required>
                    <option value="">Selecione seu Estado</option>
                    <option value="AC">Acre</option>
                    <option value="AL">Alagoas</option>
                    <option value="AP">Amapá</option>
                    <option value="AM">Amazonas</option>
                    <option value="BA">Bahia</option>
                    <option value="CE">Ceará</option>
                    <option value="DF">Distrito Federal</option>
                    <option value="ES">Espírito Santo</option>
                    <option value="GO">Goiás</option>
                    <option value="MA">Maranhão</option>
                    <option value="MT">Mato Grosso</option>
                    <option value="MS">Mato Grosso do Sul</option>
                    <option value="MG">Minas Gerais</option>
                    <option value="PA">Pará</option>
                    <option value="PB">Paraíba</option>
                    <option value="PR">Paraná</option>
                    <option value="PE">Pernambuco</option>
                    <option value="PI">Piauí</option>
                    <option value="RJ">Rio de Janeiro</option>
                    <option value="RN">Rio Grande do Norte</option>
                    <option value="RS">Rio Grande do Sul</option>
                    <option value="RO">Rondônia</option>
                    <option value="RR">Roraima</option>
                    <option value="SC">Santa Catarina</option>
                    <option value="SP">São Paulo</option>
                    <option value="SE">Sergipe</option>
                    <option value="TO">Tocantins</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            <Form.Group>
              <Form.Label htmlFor="email" className="oswald">E-mail</Form.Label>
              <Form.Control type="email" name="email" id="email" aria-describedby="emailHelp" placeholder="Digite seu e-mail pessoal" required />
            </Form.Group>
            <Row>
              <Col xs={12} sm={6}>
                <Form.Group>
                  <Form.Label htmlFor="password" className="oswald">Senha</Form.Label>
                  <Form.Control type="password" name="password" id="password" placeholder="Digite sua senha" required autoComplete="current-password" />
                </Form.Group>
              </Col>
              <Col xs={12} sm={6}>
                <Form.Group>
                  <Form.Label htmlFor="passwordConfirm" className="oswald">Confirmar Senha</Form.Label>
                  <Form.Control type="password" name="passwordConfirm" id="passwordConfirm" placeholder="Digite a confirmação da sua senha" required />
                </Form.Group>
              </Col>
            </Row>
            <Form.Group>
              <Form.Check
                type="switch"
                id="termAgree"
                name="termAgree"
                label={(
                  <>
                    <span>Li e concordo com a </span>
                    <a href="/psi.pdf" target="_blank">PSI</a>
                    <span>, e afirmo ser maior de 18 anos.</span>
                  </>
                )}
              />
            </Form.Group>
          </Modal.Body>
          <Divider color="gray" />
          <div className="d-grid gap-2 ps-3 pe-3 pb-3">
            <Button type="submit" className="shadow-sm">Cadastrar</Button>
            <Button variant="light" className="shadow-sm" onClick={handleLogin}>Cancelar</Button>
          </div>
        </Form>
      </Modal>
    </>
  );
}
